import { render, staticRenderFns } from "./CompanyOdcTable.vue?vue&type=template&id=cd37ee70"
import script from "./CompanyOdcTable.vue?vue&type=script&lang=js"
export * from "./CompanyOdcTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd37ee70')) {
      api.createRecord('cd37ee70', component.options)
    } else {
      api.reload('cd37ee70', component.options)
    }
    module.hot.accept("./CompanyOdcTable.vue?vue&type=template&id=cd37ee70", function () {
      api.rerender('cd37ee70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popups/closings-details/components/CompanyOdcTable.vue"
export default component.exports